import DOMPurify from 'dompurify';

/** Экземпляр очистки оформленного содержимого сообщений; создаётся при первой очистке. */
let contentHtmlPurifier: ReturnType<typeof DOMPurify> | null = null;

/**
 * Свой экземпляр, а не общий: правило ссылок ниже действует только на содержимое сообщений,
 * общие настройки очистки приложения (форматированный текст, логотип) оно не задевает.
 */
const getContentHtmlPurifier = (): ReturnType<typeof DOMPurify> => {
  if (contentHtmlPurifier) return contentHtmlPurifier;

  const purifier = DOMPurify(window);
  // Ссылка из чужого содержимого открывается в новой вкладке, без доступа к открывшему окну
  purifier.addHook('afterSanitizeAttributes', (node) => {
    if (node.nodeName === 'A' && node.hasAttribute('href')) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  contentHtmlPurifier = purifier;
  return purifier;
};

/**
 * Теги, которые из содержимого сообщения убираются, хотя исполняемого в них нет: таблица стилей
 * письма перекрасила бы всю страницу, а поля формы в облаке переписки не к чему заполнять.
 */
const CONTENT_HTML_FORBIDDEN_TAGS = ['style', 'form', 'input', 'button', 'textarea', 'select', 'option'];

/**
 * Очищает оформленное содержимое сообщения (HTML из внешней системы): остаётся разметка
 * оформления, картинки и ссылки, а всё исполняемое — скрипты, обработчики событий,
 * опасные адреса — убирается.
 */
export const sanitizeHtml = (html: string): string =>
  getContentHtmlPurifier().sanitize(html, { USE_PROFILES: { html: true }, FORBID_TAGS: CONTENT_HTML_FORBIDDEN_TAGS });
